module.exports = __webpack_public_path__ + "media/components/locations/shared/images/clutter_pin-675ca9cc0197e24f5397857f9aeed108.svg";